import React, { useContext, useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CommonInputField from "../common/CommonInputField";
import translations from "../common/Translations";
import AppContext from "../../context/AppContext";

export const ProtectionForm = () => {
  const { langMode, theme } = useContext(AppContext);
  const [extendedDate, setExtendedDate] = useState(null);
  const todayPicker = useMemo(() => {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  }, []);
  return (
    <div>
      <div className="bg-white p-5">
        <div className="w-3/5">
          <div className="mt-10 grid grid-cols-1 gap-x-8 gap-y-10 sm:grid-cols-4">
            <div className="sm:col-span-2 mt-4">
              <CommonInputField
                label={"Enter account number to be protected"}
              />
            </div>
            <div className="sm:col-span-2 flex gap-4">
              <div className="flex flex-col mt-0 mb-10">
                <label className="text-xs">{translations[langMode].enterextendeddate}</label>
                <DatePicker
                  selected={extendedDate}
                  onChange={setExtendedDate}
                  placeholderText={translations[langMode].enterextendeddate}
                  maxDate={todayPicker}
                  className={`w-[300px] h-12 px-2 !rounded-lg text-sm border border-gray-300 ${theme === "dark" ? "dark-mode border-gray-200 placeholder-white" : theme === "high-contrast" ? "high-contrast" : ""}`}
                  calendarClassName="!rounded-lg shadow-lg"
                  popperPlacement="bottom-start"
                  popperContainer={({ children }) => (
                    <div style={{ position: "fixed", zIndex: 100000 }}>{children}</div>
                  )}
                />
              </div>
            </div>
            <div className="sm:col-span-2">
            <CommonInputField
                label={translations[langMode].targetoutstandingamtbyextdate}
              />
            </div>
            <div className="sm:col-span-2">
            <CommonInputField
                label={translations[langMode].Comments}
              />
            </div>
          </div>
        </div>
        <div className="mt-40">
          <div className="sm:col-span-4">
            <hr className="w-full border-gray-300" />
          </div>
          <div className="sm:col-span-4 pt-5 flex justify-end items-center">
            <button data-button-intent="success"
              type="submit"
              className="px-3 py-2 text-white bg-blue-800 hover:bg-blue-900 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
              {translations[langMode].submit}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
